export async function fetchCEP(cep) {
  const clean = cep.replace(/\D/g, '');
  if (clean.length !== 8) throw new Error('CEP inválido');
  const res = await fetch(`https://viacep.com.br/ws/${clean}/json/`);
  if (!res.ok) throw new Error('Erro na busca do CEP');
  const data = await res.json();
  if (data.erro) throw new Error('CEP não encontrado');
  return {
    logradouro: data.logradouro || '',
    bairro:     data.bairro     || '',
    cidade:     data.localidade || '',
    uf:         data.uf         || '',
  };
}
